import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/user/userSlice";
import guestCartReducer from "../features/user/guestCartSlice";
import productReducer from "../features/products/productSlilce";
import blogReducer from "../features/blogs/blogSlice";
import contactReducer from "../features/contact/contactSlice";
import brandReducer from "../features/brands/brandSlice";
import categoryReducer from "../features/categories/categorySlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    guestCart: guestCartReducer,
    product: productReducer,
    blog: blogReducer,
    contact: contactReducer,
    brand: brandReducer,
    category: categoryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'auth/login/rejected',
          'auth/register/rejected',
          'product/getAllProducts/rejected',
          'blog/getAllBlogs/rejected'
        ],
        ignoredActionsPaths: ['meta.arg', 'payload', 'error'],
        ignoredPaths: ['auth.error', 'product.error', 'blog.error'],
      },
    }),
});
